// Unpublished Work © 2022-2025 Deere & Company.

export const emptyArrayResponse = [];

export const emptyListResponse = {
    values: [],
    total: 0,
};

// StaleTime: 30 seconds
export const DEFAULT_STALE_TIME = 30000;
export const REFETCH_INTERVAL = 30000;
